import * as yup from "yup";

export const loginValidationSchema = yup
  .object({
    username: yup.string().trim().required(),
    password: yup.string().trim().required(),
  })
  .required();
